import React, { Component } from 'react';
import Big3Common from '../../js/Big3Common';
import { Link } from 'react-router-dom';


/* 개발담당:양유빈
 * 화면기능:최신 공지 알림
 * 세부설명:
*/

export class MainNoticeMgt extends Component {
    static displayName = MainNoticeMgt.name;

    constructor(props) {
        super(props);
        this.state = {
            MainNotice: [],
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    }

    render() {
        let MainNotice = [];
        if (Big3Common.Util.GetContentState(this.props, "MainNotice", null) !== null) {
            MainNotice = this.props.MainNotice;
        }
        if (MainNotice.length > 0) {
            const Title = MainNotice[0].noti_title;
            const Notino = MainNotice[0].notino;
            const Noti_Idx = MainNotice[0].noti_idx;
            const WUid = MainNotice[0].wuid

            const Url = `/MyPage/Notice/Index?Notino=${Notino}&Noti_Idx=${Noti_Idx}&WUid=${WUid}`;
            return (
                <div>
                    <div className="notice_info_box_wrap">
                        <Link to={Url} >
                            <div className="notice_info_box">
                                {Title}
                                <div className="close"></div>
                            </div>
                        </Link>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
